import { render, staticRenderFns } from "./request-sent.vue?vue&type=template&id=12be4160"
import script from "./request-sent.vue?vue&type=script&lang=js"
export * from "./request-sent.vue?vue&type=script&lang=js"
import style0 from "./request-sent.vue?vue&type=style&index=0&id=12be4160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports